(function () {

const CONFIG = {
  thresholdCents: 8900,
  qualifyingVendor: "Mai Désirée",
  giftVariantIds: [51817213591832, 51817213624600],
  giftTagProperty: "_wonena_auto_gift",
  debug: true
};

const log = (...args) => {
  if (CONFIG.debug) console.log("[auto-gift]", ...args);
};

const endpoints = {
  cart: "/cart.js",
  add: "/cart/add.js",
  change: "/cart/change.js"
};

let running = false;

async function getCart() {
  const res = await fetch(endpoints.cart, { credentials: "same-origin" });
  return await res.json();
}

function isGift(item) {
  const tagged =
    item.properties &&
    item.properties[CONFIG.giftTagProperty] === "true";

  const variantMatch = CONFIG.giftVariantIds.includes(Number(item.variant_id));

  return tagged && variantMatch;
}

function vendorSubtotal(cart) {
  return cart.items.reduce((sum, item) => {

    if (isGift(item)) return sum;

    const vendorMatch =
      (item.vendor || "").toLowerCase() ===
      CONFIG.qualifyingVendor.toLowerCase();

    if (!vendorMatch) return sum;

    return sum + item.final_line_price;

  }, 0);
}

function findGiftLines(cart) {
  return cart.items.filter(item => isGift(item));
}

async function addGift() {

  const variant = CONFIG.giftVariantIds[0];

  log("Adding gift", variant);

  await fetch(endpoints.add, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [{
        id: variant,
        quantity: 1,
        properties: {
          [CONFIG.giftTagProperty]: "true"
        }
      }]
    })
  });

}

async function removeGift(key) {

  log("Removing gift");

  await fetch(endpoints.change, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: key,
      quantity: 0
    })
  });

}

async function enforce() {

  if (running) return;
  running = true;

  try {

    const cart = await getCart();
    const subtotal = vendorSubtotal(cart);
    const gifts = findGiftLines(cart);

    log("Vendor subtotal:", subtotal);
    log("Gift lines:", gifts);

    const qualifies = subtotal >= CONFIG.thresholdCents;

    if (qualifies && gifts.length === 0) {
      await addGift();
      location.reload();
    }

    if (!qualifies && gifts.length > 0) {
      await removeGift(gifts[0].key);
      location.reload();
    }

  } catch (e) {
    console.error(e);
  }

  running = false;

}

function debounce(fn, delay = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), delay);
  };
}

const check = debounce(enforce);

document.addEventListener("DOMContentLoaded", check);

const originalFetch = window.fetch;

window.fetch = async function (...args) {

  const res = await originalFetch.apply(this, args);

  try {

    const url = typeof args[0] === "string" ? args[0] : args[0].url;

    if (
      url.includes("/cart/add") ||
      url.includes("/cart/change") ||
      url.includes("/cart/update") ||
      url.includes("/cart/clear")
    ) {
      setTimeout(check, 200);
    }

  } catch (e) {}

  return res;

};

})();